import cloneDeep from 'lodash/cloneDeep';
import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  data: [],
  filteredTotal: 0,
  filters: [],
  legalEntities: [],
  legalEntitiesLoaded: false,
  legalEntityEnabled: false,
  loading: false,
  sortableColumns: [],
  total: 0,
};

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, sortableColumns } = payload;

  return {
    ...state,
    data,
    filteredTotal,
    filters,
    loading: false,
    sortableColumns,
    total,
  };
}

function onLoadLegalEntitiesSuccess(state, { payload }) {
  return {
    ...state,
    legalEntities: payload,
    legalEntitiesLoaded: true,
    legalEntityEnabled: true,
  };
}

function onLoadLegalEntitiesError(state) {
  return {
    ...state,
    legalEntities: [],
    legalEntitiesLoaded: true,
    legalEntityEnabled: false,
  };
}

function onUpdateAgencyPreference(state, { payload }) {
  const { id, preference_level } = payload;
  const data = cloneDeep(state.data);

  const prevAgency = data.find(item => item.preference_level === preference_level);
  const agency = data.find(item => item.id === id);

  prevAgency.preference_level = agency.preference_level;
  agency.preference_level = preference_level;

  data.sort((a, b) => a.preference_level - b.preference_level);

  return { ...state, data };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_LEGAL_ENTITIES_ERROR]: onLoadLegalEntitiesError,
  [actions.LOAD_LEGAL_ENTITIES_SUCCESS]: onLoadLegalEntitiesSuccess,
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.UPDATE_PREFERENCE_REQUEST]: onUpdateAgencyPreference,
  [actions.CLEAR_STORE]: onClearStore,
});
